module.exports = __webpack_public_path__ + "img/modal-btn-bg-1.0b6211f1.png";